import React, {Component, Fragment} from 'react';

import Button from '@material-ui/core/Button/index';
import Dialog from '@material-ui/core/Dialog/index';
import DialogActions from '@material-ui/core/DialogActions/index';
import DialogContent from '@material-ui/core/DialogContent/index';
import DialogTitle from '@material-ui/core/DialogTitle/index';
import Slide from "@material-ui/core/Slide/index";
import DraggableModal from "../../../Include/DraggableModal/DraggableModal";
import {FieldsJs} from "../../../../settings/General/General";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import {ReactLocalStorageService} from "../../../../settings/ReactLocalStorageService/ReactLocalStorageService";
import Divider from "@material-ui/core/Divider";
import Table from '@material-ui/core/Table/index';
import TableBody from '@material-ui/core/TableBody/index';
import TableCell from '@material-ui/core/TableCell/index';
import TableHead from '@material-ui/core/TableHead/index';
import TableRow from '@material-ui/core/TableRow/index';
import Paper from '@material-ui/core/Paper/index';
import {CatService} from "../../../../services/_Cat/CatService/CatService";
import {PopupService} from "../../../../settings/PoPup/PoPup";
import {CONFIG} from "../../../../settings/Config/Config";
import icon_mas from "../../../../assets/img/icons/expandir-mas.svg";
import icon_menos from "../../../../assets/img/icons/expandir-menos.svg";


class ModalVerOrdenes extends Component {
	
	state = {};
	
	Usr = {};
	
	constructor(props) {
		super(props);
		
		this.Usr = ReactLocalStorageService.get('Usr') || {};
		
		this.state = {
			ordenesVenta: this.props.ordenesVenta,
			modal: {
				open: false
			},
			tipo: props.tipo || '',
			numero_orden: '',
			ids_expandido: [],
		};
	}
	
	handleChange = (e, variable, campo, date, input) => {
		
		if ((date && input) || input) {
			
			this.setState({
				[input]: date
			});
			
		} else {
			
			let {value, name, checked, type} = e.target;
			
			
			if (name === "factura_cotizacion_nota_sencilla_interno" && value === "factura") {
				this.setState({
					desglosar_iva: true,
					no_desglosar_iva: false
				});
			}
			
			if (name === "factura_cotizacion_nota_sencilla_interno" && value === "nota_sencilla") {
				this.setState({
					no_desglosar_iva: true,
					desglosar_iva: false
				});
			}
			
			if (name === "factura_cotizacion_nota_sencilla_interno" && value === "cotizacion") {
				this.setState({
					modalincluyeiva: true,
					no_desglosar_iva: true,
					desglosar_iva: false
				});
			} else {
				this.setState({
					modalincluyeiva: false
				});
			}
			
			
			if (variable && campo) {
				
				let key = Number(name.split('__')[1]);
				
				let arr_temp = this.state[variable];
				
				
				for (let i = 0; i < arr_temp.length; i++) {
					
					if (key === i) {
						arr_temp[i][campo] = type === 'checkbox' ? checked : value;
					}
				}
				
				
				this.setState({
					[variable]: arr_temp
				});
			} else {
				console.log(name);
				
				if (name === "no_desglosar_iva" && this.state.no_desglosar_iva) {
					checked = true;
				}
				if (name === "desglosar_iva" && this.state.desglosar_iva) {
					checked = true;
				}
				if (name === "no_desglosar_iva" && !this.state.no_desglosar_iva) {
					this.setState({
						desglosar_iva: false
					});
				}
				if (name === "desglosar_iva" && !this.state.desglosar_iva) {
					this.setState({
						no_desglosar_iva: false
					});
				}
				if (name === "no_desglosar_iva" && this.state.factura_cotizacion_nota_sencilla_interno === "factura") {
					checked = false;
					this.setState({
						desglosar_iva: true
					});
				}
				
				this.setState({
					[name]: type === 'checkbox' ? checked : value
				});
				
				
			}
		}
	};
	
	changeValue = (arr_name__key, var_name, var_value) => {
		FieldsJs.ChangeValue(arr_name__key, var_name, var_value, (r) => this.setState({
			[r.name]: r.value
		}), this.state);
	};
	
	openModal = () => {
		this.setState({
			modal: {
				open: true
			},
			numero_orden: this.props.numero_orden || '',
		});
		console.log("OPEN MODAL >>> ", this.props)
	};
	
	closeModal = () => {
		this.setState({
			modal: {
				open: false
			}
		});
	};
	
	open = () => {
		this.init().then(r => {
			setTimeout(() => this.openModal());
		}).catch(e => {
			console.log(e);
		});
	};
	
	close = () => {
		this.closeModal();
	};
	
	init = () => {
		return new Promise((resolve, reject) => {
			this.props.numeroOrdenVenta().then(res => {
				resolve(true);
			});
		});
	};
	
	is_view = () => {
		return this.props.tipo === 'view';
	};
	
	is_edit = () => {
		return this.props.tipo === 'edit';
	};
	
	is_add = () => {
		return this.props.tipo === 'add';
	};
	
	is_root = () => {
		return FieldsJs.inArray([1], this.Usr.id_cat_tipo_usuario);
	};
	
	
	save = () => {
		
		console.log(this.state);
		let btn = ['Cancelar', 'Aceptar'];
		let msg = '¿Seguro que deseas guardar las ordenes de venta?';
		
		PopupService.Confirm(btn, 'info', CONFIG.titulo_alert_confirm, msg).then((r) => {
			if (r.button === btn[1]) {
				this.props.OrdenDeVentaGuardarTemporalPartida();
				this.closeModal();
			}
		});
		
		/*CotizadorService.Nube(formData).then((response) => {
			
			this.props.RefreshList();
			this.props.showSnackBars('success', response.mensaje);
		}).catch((error) => {
			this.props.showSnackBars('error', error.mensaje);
		});*/
	};
	
	
	ShowSubTabla = (item, key) => {
		let expandir = !!!item.expandir;
		this.handleChange({
			target: {
				value: expandir,
				name: 'expandir__' + key,
				type: 'text'
			}
		}, 'ordenesVenta', 'expandir');
		let ids_temp = this.state.ids_expandido;
		let ids_expandido = [];
		if (expandir) {
			ids_expandido = ids_temp;
			ids_expandido.push({
				id_orden_venta: item.id_orden_venta
			});
		} else {
			for (let i = 0; i < ids_temp.length; i++) {
				if (Number(ids_temp[i].id_orden_venta) !== Number(item.id_orden_venta)) {
					ids_expandido.push({
						id_orden_venta: ids_temp[i].id_orden_venta
					})
				}
			}
			
		}
		this.setState({
			ids_expandido: ids_expandido
		});
	};
	
	render() {
		let {item} = this.props;
		
		
		
		const bg_mas = {
			backgroundImage: `url(${icon_mas})`
		};
		
		const bg_menos = {
			backgroundImage: `url(${icon_menos})`
		};
		
		return (
			<div>
				
				{this.props.componente ? (
					<Fragment>
						<span onClick={() => this.open()} style={{cursor: 'pointer'}}>
							{this.props.componente}
						</span>
					</Fragment>
				) : null}
				
				<Dialog open={this.state.modal.open} onClose={() => this.close()} PaperComponent={DraggableModal}
				        disableEscapeKeyDown disableBackdropClick maxWidth={'lg'} fullWidth={true} scroll={'paper'}
				        transition={<Slide direction="up"/>} aria-labelledby="scroll-dialog-title" className={'cotizador'}
				>
					
					<DialogTitle>
						<Grid container spacing={2}>
							<Grid item xs={6} align={'left'}>
								Orden de Venta
							</Grid>
							<Grid item xs={6} align={'right'}>
								{this.state.numero_orden}
							</Grid>
						</Grid>
					</DialogTitle>
					
					<DialogContent>
						
						<Grid container spacing={2} className={'cotizador_fondo'}>
							<Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
								<Paper style={{width: '100%'}}>
									
									
											<Table className={'desing-mark'}>
												<TableHead>
													<TableRow>
														<TableCell component="th" align={'left'} className={'padding-20-L padding-20-R'}>...</TableCell>
														<TableCell component="th" align={'left'}>Orden</TableCell>
														<TableCell component="th" align={'left'}>Cliente</TableCell>
														<TableCell component="th" align={'left'}>Tipo</TableCell>
														<TableCell component="th" align={'left'}>Fecha de Entrega</TableCell>
														<TableCell component="th" align={'left'}>Total</TableCell>
													</TableRow>
												</TableHead>
												<TableBody>
													{this.state.ordenesVenta.map((item, key) => {
														return (
															<Fragment>
																<TableRow key={key}>
																	<TableCell align={'left'} className={'padding-20-L padding-20-R'}>
																		<div style={!!item.expandir ? bg_menos : bg_mas}
																		     className={'bg-img-contain-x-center-y-center h-20-px w-20-px cursor-pointer'}
																		     onClick={() => this.ShowSubTabla(item, key)}
																		/>
																	</TableCell>
																	<TableCell align={'left'}>{key+1}</TableCell>
																	<TableCell align={'left'}>{item.cliente}</TableCell>
																	<TableCell align={'left'}>{item.tipo_factura}</TableCell>
																	<TableCell align={'left'}>{item.fecha_entrega}</TableCell>
																	<TableCell align={'left'}>${FieldsJs.Currency(item.total)}</TableCell>
																</TableRow>
																
																{!!item.expandir ? (
																	<Fragment>
																		<TableRow>
																			<TableCell colSpan={6} component="th" align={'center'} className={'padding-20-L padding-20-R'}>Producto(s)</TableCell>
																		</TableRow>
																	
																		<TableRow>
																			<TableCell colSpan={6} component="th" className={'padding-20-L padding-20-R'}>
																				{item.venta_producto.map((prod, key) => {
																					return (
																						<Table className={'desing-mark'}>
																							<TableHead>
																								<TableRow>
																									<TableCell component="th" align={'left'} className={'padding-20-L padding-20-R'}>Producto</TableCell>
																									<TableCell component="th" align={'left'}>Descripción</TableCell>
																									<TableCell component="th" align={'left'}>Cantidad</TableCell>
																									<TableCell component="th" align={'left'}>Precio Unitario</TableCell>
																									<TableCell component="th" align={'left'}>Costo Adicional</TableCell>
																									<TableCell component="th" align={'left'}>Descuento</TableCell>
																									<TableCell component="th" align={'left'}>Precio</TableCell>
																								</TableRow>
																							</TableHead>
																							<TableBody>
																								<TableRow key={key}>
																									<TableCell align={'left'} className={'padding-20-L padding-20-R'}>{prod.venta_producto}</TableCell>
																									<TableCell align={'left'}>{prod.venta_descripcion}</TableCell>
																									<TableCell align={'left'}>{prod.venta_cantidad}</TableCell>
																									<TableCell align={'left'}>{prod.venta_precio_unitario}</TableCell>
																									<TableCell align={'left'}>{prod.venta_costo_adicional}</TableCell>
																									<TableCell align={'left'}>{prod.venta_descuento}</TableCell>
																									<TableCell align={'left'}>{prod.venta_precio}</TableCell>
																								</TableRow>
																							</TableBody>
																						</Table>
																					)
																				})}
																			</TableCell>
																		</TableRow>
																		
																		<TableRow>
																			<TableCell colSpan={6} component="th" align={'center'} className={'padding-20-L padding-20-R'}>Forma Pago</TableCell>
																		</TableRow>
																		
																		<TableRow>
																			<TableCell colSpan={6} component="th" className={'padding-20-L padding-20-R'}>
																				<Table className={'desing-mark'}>
																					<TableHead>
																						<TableRow>
																							<TableCell component="th" align={'left'} className={'padding-20-L padding-20-R'}>Forma de Pago</TableCell>
																							<TableCell component="th" align={'left'}>Monto</TableCell>
																							<TableCell component="th" align={'left'}>Pago con</TableCell>
																							<TableCell component="th" align={'left'}>Cambio</TableCell>
																						
																						</TableRow>
																					</TableHead>
																					<TableBody>
																						<TableRow key={key}>
																							<TableCell align={'left'} className={'padding-20-L padding-20-R'}>{item.forma_pago.forma_pago}</TableCell>
																							<TableCell align={'left'}>{item.forma_pago.monto}</TableCell>
																							<TableCell align={'left'}>{item.forma_pago.pago_con}</TableCell>
																							<TableCell align={'left'}>{item.forma_pago.cambio}</TableCell>
																						</TableRow>
																					</TableBody>
																				</Table>
																			</TableCell>
																		</TableRow>
																	</Fragment>
																	):null}
																	
															</Fragment>
														
														)}
													)}
													
													
													
												</TableBody>
											</Table>
										
								</Paper>
							</Grid>
						</Grid>
					
					</DialogContent>
					
					<Divider/>
					
					<DialogActions>
						<Grid container spacing={2}>
							<Grid item xs={6} align={'left'}>
								<Button variant="contained" onClick={() => this.close()} color="secundary">
									Cerrar
								</Button>
							</Grid>
							<Grid item xs={6} align={'right'}>
								<Button variant="contained" onClick={() => this.save()} color="primary">
									Continuar
								</Button>
							</Grid>
						</Grid>
					</DialogActions>
				
				</Dialog>
			
			</div>
		);
	}
}

ModalVerOrdenes.propTypes = {
	componente: PropTypes.element.isRequired,
	RefreshList: PropTypes.func.isRequired,
	showSnackBars: PropTypes.func.isRequired,
	numeroOrdenVenta: PropTypes.func.isRequired,
	OrdenDeVentaGuardarTemporalPartida: PropTypes.func.isRequired,
	ordenesVenta: PropTypes.array.isRequired,
	numero_orden: PropTypes.string,
};

export default ModalVerOrdenes;
